/**
 * Wrapper typé autour de `document.cookie` pour les clés utilisées par Sarah.
 *
 * Clés connues : `user_choices` (Record), `user_map` (string[]),
 * `user_visitor` (string JSON), `a-commonAccess`, `a-refreshAccess`, `a-userId`.
 */
export class CookieStore {
  get(name: string): string {
    // RegExp construite à la volée car le nom de cookie est dynamique ;
    // l'API ne sert qu'aux clés Sarah, donc pas d'échappement nécessaire.
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  set(name: string, value: string, days?: number, path?: string): void {
    let s = name + '=' + encodeURIComponent(value);
    if (days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      s += '; expires=' + d.toUTCString();
    }
    s += '; path=' + (path || '/');
    document.cookie = s;
  }

  getJSON<T>(name: string, fallback: T): T {
    const raw = this.get(name);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  }

  setJSON(name: string, value: unknown, days?: number, path?: string): void {
    this.set(name, JSON.stringify(value), days, path);
  }

  delete(name: string, path?: string): void {
    // Expiration dans le passé = suppression côté navigateur.
    document.cookie =
      name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + (path || '/');
  }
}
